import Vue from 'vue';
import Component from 'vue-class-component';
import { postForm } from '@/utils/CrmHttp';
import load from '@/assets/images/upLoading.gif';

@Component({
  components: {},
})
export default class BankCar extends Vue {
	/**
   * name
   */
  public formData = {
    name: '',
    bank: '',
    bankBranch: '',
    bankNo: '',
  };
  public load = load;
  public loadFlage: boolean = false;
  public bankCarList: any[] = [];
  public errorMsg: string = '';
  public hintMsg: boolean = false;
  public flage = true;
  public headline: string = '添加银行卡';
  public showPopup: boolean = false;
  // 添加银行卡
  public addCar() {
    if (this.loadFlage) {
      return;
    }
    this.flage = false;
    this.headline = '添加银行卡';
    this.showPopup = true;
  }
  public cancelP() {
    this.showPopup = false;
    this.clearData();
  }
  // 查看银行卡
  public editCar(item) {
    this.flage = true;
    this.headline = '银行卡信息';
    this.formData.name = item.name;
    this.formData.bank = item.bankName;
    this.formData.bankBranch = item.branchName;
    this.formData.bankNo = item.bankNo;
    this.showPopup = true;
  }
  public closeP() {
    this.showPopup = false;
    this.clearData();
  }
  public activated() {
    this.clearData();
    this.getList();
  }
  // 确认添加/编辑银行卡
  public async enterAddCar() {

    if (!this.formData.name) {
      this.errorMsg = '请正确填写持卡人姓名';
      this.hintMsg = true;
      this.vanish();
      return false;
    } else if (!this.formData.bankNo) {
      this.errorMsg = '请正确填写银行卡号';
      this.hintMsg = true;
      this.vanish();
      return false;
    } else if (!/^\d{15,19}$/.test(this.formData.bankNo)) {
      this.errorMsg = '银行卡号错误';
      this.hintMsg = true;
      this.vanish();
      return false;
    } else if (!this.formData.bank) {
      this.errorMsg = '请正确填写开户行';
      this.hintMsg = true;
      this.vanish();
      return false;
    } else if (!this.formData.bankBranch) {
      this.errorMsg = '请正确填写分行信息';
      this.hintMsg = true;
      this.vanish();
      return false;
    }
    try {
      this.loadFlage = true;
      await postForm('/api/user-bank/add', {
        Name: this.formData.name,
        BankNo: this.formData.bankNo,
        BankName: this.formData.bank,
        BranchName: this.formData.bankBranch,
      });
      this.errorMsg = '添加成功';
      this.hintMsg = true;
      this.getList();
      this.clearData();
      this.showPopup = false;
    } catch (error) {
      this.errorMsg = '添加失败';
      this.hintMsg = true;
    }
    this.loadFlage = false;
    this.hintMsg = true;
    this.vanish();
  }
  // 删除银行卡
  public async deleData(index) {
    this.loadFlage = true;
    await postForm('/api/user-bank/del', {
      id: index,
    });
    this.errorMsg = '删除成功';
    this.hintMsg = true;
    this.vanish();
    this.getList();
    this.loadFlage = false;
  }
  // 获取银行卡列表
  public async getList() {
    this.loadFlage = true;
    this.bankCarList = [];
    if(process.env.NODE_ENV === 'development')
      console.log('data');
    const data = await postForm('/api/user-bank/query');
    for (const i of data) {
      this.bankCarList.push({
        id: i.Id,
        name: i.Name,
        bankNo: i.BankNo,
        branchName: i.BranchName,
        bankName: i.BankName,
        logNo: '**' + i.BankNo.substr(i.BankNo.length - 4),
      });
    }
    this.loadFlage = false;
    this.vanish();
    if(process.env.NODE_ENV === 'development')
      console.log(this.bankCarList);
  }

  //
  public goback() {
    this.$router.go(-1);
  }
  public vanish() {
    setTimeout(() => {
      this.hintMsg = false;
    }, 1500);
  }
  public clearData() {
    this.formData.name = '';
    this.formData.bank = '';
    this.formData.bankBranch = '';
    this.formData.bankNo = '';
  }
}



// WEBPACK FOOTER //
// ./src/views/Person/DrawMoney/BankCar/BankCar.ts